import Vue from 'vue'
import moment from 'moment'
import {convertTelNumberForUi} from '@/helpers'

Vue.filter('date', function (value: any) {
  if (!value) return ''
  return moment(value).locale('fr').format('ll')
})

Vue.filter('datetime', function (value: any) {
  if (!value) return ''
  const hours = moment(value).hours()
  const minutes = moment(value).minutes()
  if (hours === 0 && minutes === 0) return moment(value).locale('fr').format('ll')
  else return moment(value).locale('fr').format('llll')
})

Vue.filter('tel', function (value: any) {
  if (!value) return ''
  return convertTelNumberForUi(value)
})
